module.exports = __webpack_public_path__ + "img/0.2f5c529c.png";